import React from "react";
import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./DeleteModal.css";
import { toast } from "react-toastify";
import { PiSealWarning } from "react-icons/pi";
import WebService from "../../../Services/WebService";
import moment from "moment";
interface PropData {
  message?: string;
  show: boolean;
  action: string;
  onDelete: any;
  api_method?: string;
  body?: any;
  type?: any;
  btn_label?: string;
  btn_class?: string;
}

const DeleteModal = (props: PropData) => {
  const [showDelete, setShowDelete] = useState(false);
  useEffect(() => {
    setShowDelete(props.show);
  });
  const handleDelete = () => {
    WebService.addLoader("delete-btn");
    WebService.apiRequest({
      method: !props.api_method ? "DELETE" : props.api_method,
      action: props.action,
      body: props.body ?? null,
    })
      .then((res: any) => {

        if (res?.is_cancelled) {

          let cancel_date = '';
          if (res?.canceled_at) {
            cancel_date = moment(res?.canceled_at).format("MM/DD/YYYY");
          }

          localStorage.setItem("is_canceled_schedule", "1");
          localStorage.setItem("cancel_schedule_at", cancel_date);
        } else if (res?.is_cancelled) {
          localStorage.setItem("is_canceled_schedule", "0");
          localStorage.removeItem("cancel_schedule_at");
        }

        toast(res.message ?? "Deleted successfully!", {
          position: "top-right",
          type: "success",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        props.onDelete(true);
        WebService.removeLoader("delete-btn");
        setShowDelete(false);
      })
      .catch((error: any) => {
        WebService.removeLoader("delete-btn");
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        }
        setShowDelete(false);
        props.onDelete(false);
        return error;
      });
  };
  const handleCloseDelete = () => {
    setShowDelete(false);
    props.onDelete(false);
  };
  return showDelete ? (
    <Modal show={showDelete} onHide={handleCloseDelete} centered>
      <Modal.Header
        closeButton
        onClick={() => handleCloseDelete}
        className=" border-0 pb-0"
      ></Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <h2 className="text-danger">
            <PiSealWarning size={70} />
          </h2>
          <h4 className="font-18">
            {!props.message ? (props.type === "DISCONNECT"
              ? "Are you sure you want to disconnect ?"
              : "Are you sure you want to delete ?")
              : props.message
            }
          </h4>
        </div>
      </Modal.Body>
      <Modal.Footer className=" justify-content-center border-0 pt-0">
        <Button className="btn-light" onClick={handleCloseDelete}>
          Cancel
        </Button>
        <Button className={props.btn_class ? props.btn_class : "btn-danger"} onClick={handleDelete} id="delete-btn">
          {props.btn_label ? props.btn_label : (props.type === "DISCONNECT" ? "Disconnect" : "Delete")}
        </Button>
      </Modal.Footer>
    </Modal>
  ) : (
    <></>
  );
};

export default DeleteModal;
